import { React, useContext, useState } from "react";
import HomeImg from "../../assets/home-img.png";
import { auth } from '../../firebase/firebase';
import { signOut } from 'firebase/auth';
import { replace, useNavigate } from 'react-router-dom';
import { AuthContext } from "../../context/AuthContext";
export default function ErrorPage() {
  const navigate = useNavigate();
  const { logOut, user} = useContext(AuthContext);

  const handleSubmit = async () => {
    try {
      console.log(user);
      if (user) {
        // Navigate to '/stats' and replace the current entry in the history stack
        navigate('/stats', { replace: true });
      } else {
        // If no user, navigate to the homepage
        navigate('/',{ replace: true });
      }
    } catch (error) {
      console.error("Error during handleSubmit:", error);
    }
  };
  
  const handleLogin = async () => {
    try {
      // Log out the user first
      await logOut();
      // After logging out, navigate to the homepage
      navigate("/",{ replace: true });
    } catch (error) {
      console.error("Error during handleLogin:", error);
    }
  };
  
  return (
    <>
      <div className="h-100">
        <div className="w-full bg-[#030303] text-gray-900 flex justify-center items-center">
          {/* <div className="home__container container flex items-center justify-center"> */}
          <div className="home__data flex flex-col justify-center items-start">
            <p className="pb-2 font-semibold text-white">Error 404</p>
            <h1 className="pb-4 text-5xl font-bold lg:text-6xl text-white">
              Hey Buddy
            </h1>
            <p className="pb-8 font-semibold text-white">
              We can't seem to find the page <br />
              you are looking for.
            </p>
            <div className="flex justify-end">
              <button onClick={handleLogin} className="inline-flex items-center justify-center  rounded-full bg-[#ff050d] py-4 px-8 font-bold text-white">
                Go Home
              </button>
            </div>
            {/* <div className="flex justify-end">
              <button onClick={handleLogin} className="inline-flex items-center justify-center mt-2 rounded-full bg-[#ff050d] py-4 px-8 font-bold text-white">
                Login Again
              </button>
            </div> */}
        
           
          </div>
          

          <div className="home__img">
            <img src={HomeImg} className="w-48 lg:w-[400px]" alt="home" />
            {/* <div className="home__shadow mx-auto h-8 w-36 animate-shadow rounded-[50%] bg-gray-900/30 blur-md lg:w-64"></div> */}
          </div>
          {/* </div> */}
        </div>
        <div className="flex w-full mt-10 justify-center space-x-2 items-center text-white bg-[#ff050d]">
          <p>0891 2345 6789</p>
          <p>|</p>
          <p>info@xcompany.com</p>
        </div>
      </div>
    </>
  );
}
